export default {
  tabs: {
    access: 'Accesso',
    notification_preferences: 'Preferenze notifiche',
  },
  sections: {
    notification_preferences: {
      title: 'Preferenze notifiche',
      form: {
        has_voice_call_reminders: {
          label: 'Ricevi chiamate automatiche sugli ordini in sospeso',
        },
        voice_reminders_phone_number: {
          label: 'Numero di telefono per ricevere chiamate',
        },
        has_whatsapp_notifications: {
          label: 'Invia notifiche (es. ordini in pausa) via WhatsApp',
        },
        whatsapp_phone_number: {
          label: 'Numero di telefono WhatsApp',
        },
        has_order_email_notifications: {
          label: 'Invia notifiche ordini via email',
        },
        order_notifications_email: {
          label: "Indirizzo email per l'inoltro delle notifiche ordini",
        },
      },
    },
    voice_calls: {
      title: 'Chiamate vocali',
    },
    whats_app_notifications: {
      title: 'Notifiche WhatsApp',
    },
    order_email_notifications: {
      title: 'Notifiche email ordini',
    },
    access_control: {
      title: 'Controllo accessi',
      form: {
        company_ids: {
          label: 'Può accedere ai ristoranti',
          tooltip: 'Fornisce accesso ai seguenti ristoranti (in aggiunta ai ristoranti dello stesso marchio)',
        },
      },
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_save_changes: 'Impossibile salvare le modifiche',
    changes_got_saved: 'Modifiche salvate',
  },
};
